"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="calltoaction" ref={ref} className="w-full !bg-[hsl(32,29%,42%)] ![padding:96px_0px_128px_0px]">
      <div className={`container mx-auto flex max-w-4xl flex-col items-center gap-8 px-4 text-center transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <h2 className="font-display font-bold !text-5xl !text-[hsl(0,0%,100%)]">Start Your Renovation with Confidence</h2>

        <p className="max-w-3xl font-sans text-lg !text-[hsl(0,0%,100%)]">Every project begins with a conversation.
Let <span className="font-semibold">KS LUXURY RENOVATIONS</span> guide you through a refined, transparent, and expertly managed renovation experience.</p>

        <Button asChild className="btn-primary !h-auto !px-8 !py-4 !text-lg">
          <Link to="https://ksluxury.cloudtech.com.cy/get-a-quote/">Request a Consultation</Link>
        </Button>
      </div>
    </section>;
}